var map = {
	"./AAPL_icon.svg": 1611,
	"./AMZN_icon.svg": 4375,
	"./GOOG_icon.svg": 193,
	"./META_icon.svg": 4212,
	"./MSFT_icon.svg": 4675,
	"./NVDA_icon.svg": 6842,
	"./TSLA_icon.svg": 3399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4321;